<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <h1 class="headline mb-1">Parámetros</h1>
            <v-spacer />
              <v-text-field 
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer />
              <v-btn color="primary" @click="dialogForm = true">Crear</v-btn>
          </v-card-title>
          <v-data-table 
            :headers="headers"
            :items="array_usuarios"
            loading-text="Cargando..."
            no-data-text="No hay registros a mostrar"   
            :search="search"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
              itemsPerPageText:'Registros por página'
            }"
            class="elevation-1">
            <template v-slot:item.action="{ item }">
              <v-btn fab x-small @click="editar(item)" 
              class="ma-2"
              outlined
               x-small
               fab
              
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>



              <v-btn fab x-small outlined  class="mr-2" @click="dialog=true;selected_id=item.id;">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>



            </template>
            <template v-slot:item.estado="{ item }">
              <v-chip v-if="item.estado == 'ACTIVO'" x-small color="success" text-color="white"> Activo </v-chip>
              <v-chip v-else x-small color="red" text-color="white"> Inactivo </v-chip>
            </template>
          </v-data-table>
        </v-card>
        <template>
          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline"></v-card-title>
                <v-card-text>Desea eliminar el item {{selected_id}}?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
                  <v-btn color="green darken-1" text @click="dialog = false;eliminar();  ">Si</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <v-dialog v-model="dialogForm" persistent max-width="600px">
          <v-card>
            <v-card-title class="headline">
              <span v-if="es_nueva">Nuevo parametro</span>  
              <span v-if="!es_nueva">Editar parametro</span>  
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field v-model="nombre"
                  :rules="[rules.required]"
                  label="Nombre"
                  required></v-text-field>
                <v-text-field 
                  v-model="valor"
                  label="Valor"
                  :rules="[rules.required]"
                  required>
                </v-text-field>
                <v-text-field 
                  v-model="descripcion"
                  label="Descripción"
                  :rules="[rules.required]"
                  required>
                </v-text-field>
                <v-switch
                  v-if="!es_nueva"
                  v-model="estado"
                  :label="`Estado: ${estado.toString()}`"
                  color="success"
                  hide-details
                  ></v-switch>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="reset"> Cerrar </v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" v-if="es_nueva" color="primary" class="mr-4" type="submit" @click="validate_and_save"> Grabar </v-btn>
              <v-btn :disabled="!valid" v-if="!es_nueva" color="primary" class="mr-4" type="submit" @click="validate_and_update"> Actualizar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

    import axios from "axios";

  export default {
    data () {
      return {
        search: "",
        dialog: false,
        selected_id: 0,
        notificacion_exito: false,
        headers: [
          // { text: 'Id', align: 'start', sortable: true, value: 'id' },
          { text: 'Nombre', value: 'nombre', sortable: true },
          { text: 'Valor', value: 'valor', sortable: true },
          { text: 'Descripción', value: 'descripcion', sortable: true },
          { text: 'Estado', value: 'estado', sortable: true },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        array_usuarios: [],

        current_item: null,
        valid: true,
        es_nueva: true,
        dialogForm: false,
        nombre: '',
        valor: '',
        descripcion: '',
        estado: false,
        rules: {
          required: value => !!value || 'Campo Requerido.',
          positivo_mayor_cero: value =>  0 < Number(value) || 'Campo debe ser mayor a cero'
        },
      }
    },
    mounted() {
      console.log("parametros.vue");
      this.getParametros();
    },
    methods: {
        eliminar() {
          console.log("Deleting Item id :" + this.selected_id)
          let getuser = axios.delete('Parametro/eliminar/' + this.selected_id,  { 'headers': this.$store.state.user.headers })
          return getuser.then((callback) => {
            console.log(callback.data)
            if(callback.status == 200) {
              console.log('Eliminando el item : ' + this.selected_id);
              this.array_usuarios.splice(this.array_usuarios.findIndex(e => e.id == this.selected_id), 1);
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
            } else {
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo error en el proceso' });
            }
          }).catch((error) => {
            console.log(error.response);
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo error en el proceso' });
          });
        },
        getParametros() {
          let getParametros = axios.get('Parametro/listar', { 'headers': this.$store.state.user.headers });
          return getParametros.then((callback) =>
          {
            this.array_usuarios = callback.data;
          }).catch((error) => {
            console.log("ERROR EN EL CALLBACK" + error);
          });
        },
        validate_and_save() {
          if (this.$refs.form.validate()) {
            this.dialogForm = false;
            this.$store.dispatch('SET_OVERLAY');
            let getuser = axios.post('Parametro/Crear', 
              { 'nombre': this.nombre, 'valor': this.valor , 'descripcion': this.descripcion, 'estado': 'ACTIVO'},
              { 'headers': this.$store.state.user.headers }
            )
            return getuser.then((callback) => {
              console.log(callback);
              if(callback.status ==201) {
                this.reset();
                let getMembresias = axios.get('Parametro/Recuperar/' + callback.data, { 'headers': this.$store.state.user.headers });
                return getMembresias.then((callback1) =>
                {
                  console.log(callback1);
                  if(callback1.status == 200) {
                    this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
                    this.array_usuarios.push(callback1.data);
                    this.$store.dispatch('UNSET_OVERLAY');
                  }
                }).catch((error) => {
                  this.dialogForm = true;
                  this.$store.dispatch('UNSET_OVERLAY');
                  console.log(error.response.data);
                  this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 1: ' + error.response.data });
                });
              }
            }).catch((error1) => {
              this.dialogForm = true;
              console.log(error1.response.data);
              this.$store.dispatch('UNSET_OVERLAY');
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 2: ' + error1.response.statusText });
            });
          }
        },
        validate_and_update() {
          console.log("validate_and_update");
          if (this.$refs.form.validate()) {
            this.$store.dispatch('SET_OVERLAY');
            this.dialogForm = false;
            let getuser = axios.put('Parametro/Actualizar', 
              { 'Id': this.selected_id, 'nombre': this.nombre, 'valor': this.valor, 'descripcion': this.descripcion, 'estado': (this.estado == true? 'ACTIVO': 'INACTIVO')}, 
              { 'headers': this.$store.state.user.headers }
            )
            return getuser.then((callback) => {
              if(callback.status == 200) {
                this.current_item.valor = this.valor;
                this.current_item.nombre = this.nombre;
                this.current_item.descripcion = this.descripcion;
                this.current_item.estado = (this.estado == true? 'ACTIVO': 'INACTIVO');
                this.reset();
                this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
              }
              this.$store.dispatch('UNSET_OVERLAY');
            }).catch((error) => {
              this.es_nueva = false;
              this.dialogForm = true;
              this.$store.dispatch('UNSET_OVERLAY');
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion: ' + error.response.data });
              console.log(error.response.data);
            });
          }
        },
        editar(item) {
          console.log("editando:");
          console.log(item);
          this.current_item = item;
          this.dialogForm = true;
          this.es_nueva = false;
          this.selected_id =item.id;
          this.nombre = item.nombre;
          this.valor = item.valor;
          this.descripcion = item.descripcion;
          this.estado = (item.estado == 'ACTIVO' ? true :false);
        },
        reset() {
        this.es_nueva = true;
        this.dialogForm = false;  
        this.$refs.form.reset()
      },
    }
  }
</script>